import React from "react";

const ErrorPage: React.FC = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100">
      <h1>Oops! Something Went Wrong</h1>
      <p>We're sorry, but there was an unexpected error.</p>
      <button
        className="btn btn-primary"
        onClick={() => (window.location.href = "/dashboard")}
      >
        Return to Dashboard
      </button>
    </div>
  );
};

export default ErrorPage;

